import React from 'react';
import Page from '../components/Governanca/Compliance';
import '../assets/css/little_wallet_new.css';


const Compliance = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Compliance;


/** WEBPACK FOOTER **
 ** ./src/containers/Compliance.js
 **/